export default __webpack_public_path__ + "static/media/icon-solar-energy.f9a5caea.svg";